export default __webpack_public_path__ + "static/media/adobe_xd.f15e6e45.png";